<div class="change-email page-container is-mobile">
  <div class="grid">
    <div class="columns is-centered">
      <div class="col-12 col-lg-7 ">
        <app-loader color="blue"></app-loader>
      </div>
    </div>
  </div>
</div>
